import config from '@frolight/config';
import HTTPStatusError from '@frolight/utils/HTTPStatusError';

const ROOT_URL = `${config.api.uri}/organisations`;

const OVERVIEW_URL = `${ROOT_URL}/`;
const DETAIL_URL = `${ROOT_URL}/:organisationId`;

export const getOrganisations = async (abortController, accessToken) => {
  try {
    const response = await fetch(OVERVIEW_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`
      },
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      throw err;
    }
  }
};

export const createOrganisation = async (abortController, accessToken, { organisationName }) => {
  try {
    const response = await fetch(OVERVIEW_URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`,
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify({ organisationName }),
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      throw err;
    }
  }
};

export const getOrganisation = async (abortController, accessToken, { organisationId }) => {
  try {
    const response = await fetch(DETAIL_URL.replace(':organisationId', organisationId), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`
      },
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      throw err;
    }
  }
};
